// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"752d185a","498":"8bef3ec0","545":"6d33e07c","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};